<template>
  <div>
    <Row :gutter="4">
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompany"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Button
          type="primary"
          v-hasPermission="['labelManagement:tag:correct_add']"
          @click="addOrUpdateHandle"
          >{{ $t('alarms.common.add') }}</Button
        >
      </Col>
    </Row>
    <add-or-update-label-correction
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-label-correction>
  </div>
</template>
<script>
import { getCookie } from "../../../../../utils/cookieUtil.js";
import AddOrUpdateLabelCorrection from "./AddOrUpdateLabelCorrection";
import TableLabelCorrection from "./TableLabelCorrection";
var tableLabelCorrection = TableLabelCorrection;
export default {
  name: "LabelCorrectionSearch",
  components: {
    AddOrUpdateLabelCorrection
  },
  data() {
    return {
      company: getCookie(global.companyId),
      companyList: [],
      companyId: "",
      addOrUpdateVisible: false
    };
  },
  mounted() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
      this.companyId = 1;
    }
  },
  methods: {
    // 添加
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 切换公司
    changeCompany: function() {
      eventBus.$emit("companyId", this.companyId);
      tableLabelCorrection.methods.showAll();
    }
  }
};
</script>
<style scoped>
.ivu-form-item {
  margin-bottom: 11px !important;
  vertical-align: top;
  zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/label_correction/LabelCorrectionSearch.vue